import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { Link } from "react-router-dom";
import a1 from "../Images/a1.png";
import { project_name } from "../Config/config";
import SEO from "../components/SEO";

export default function Agriculture() {
  return (
    <>
      <SEO
        title="AI ERP & CRM for Agriculture Industry"
        description="Empower agriculture businesses, farms, and food producers with EnteliPro AI ERP software. Track supply chains, crop yields, and buyer relationships."
        keywords="Agriculture ERP Software, AI in Agribusiness, Farm Management ERP, Agriculture CRM Solutions, Agribusiness Supply Chain"
        canonical="https://www.entelipro.com/Agriculture"
        ogImage="https://www.entelipro.com/static/media/a1.png"
      />

      <Navbar />

      <section className="w3l-inner-banner-main">
        <div className="about-inner inner2">
          <div className="container seen-w3">
            <ul className="breadcrumbs-custom-path">
              <li>
                <Link to="/">
                  Home{" "}
                  <span className="fa fa-angle-right" aria-hidden="true"></span>
                </Link>
              </li>
              <li className="active">Agriculture Industry</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="w3l-content-with-photo-4">
        <div className="content-with-photo4-block">
          <div className="container">
            <div className="cwp4-two row">
              <div className="col-xl-6 cwp4-image ">
                <img src={a1} alt="EnteliPro AI ERP for Agriculture and Farm Management" className="img-responsive " />
              </div>
              <div className="cwp4-text col-xl-6">
                <h1 className="header-name" style={{ fontSize: "2.3rem", fontWeight: "700", marginBottom: "1rem" }}>
                  AI ERP Software for Agriculture Industry
                </h1>
                <p className="para">
                  ERP software for the agriculture industry allows farmers and agribusinesses to
                  store and follow up on customer leads, manage distribution networks, track yields,
                  and streamline purchases of products and services.
                </p>
                <div className="jst-two-coloums mt-4">
                  <div className="icon-text">
                    <p className="para">
                      It helps develop personalized and targeted marketing activities that foster
                      lasting relationships with commodity buyers and supply chain partners.
                    </p>
                  </div>
                  <div className="icon-text mt-lx-3 pt-lx-1">
                    <p className="para">
                      Agriculture ERP systems maintain seamless collaboration with buyers, brokers,
                      and distributors while optimizing warehouse storage and inventory freshness.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="w3l-recent-work-hobbies agriculture-tight">
        <div className="recent-work ">
          <div className="container">
            <div className="left-text">
              <h3>Automate Your Agriculture Business Using ERP</h3>
              <p className="para">
                The main goal of {`${project_name}`} is to help agribusinesses build strong
                relationships with clients, automate crop and livestock management, and provide
                real-time analytics across all agricultural processes.
              </p>
              <br />
              <p className="para">
                By using ERP in your agricultural business, you can manage suppliers, customer
                orders, price history, and logistics from a unified dashboard:
                <br /><br />
                1. Access the best vendor purchase offers in real time<br /><br />
                2. Track manager productivity and field worker tasks<br /><br />
                3. Enable remote farm and warehouse monitoring<br /><br />
                4. Maintain multi-role permission levels for staff and partners
              </p>
              <br />
            </div>

            <div className="left-text">
              <h3>Essential ERP Capabilities for Modern Agribusiness</h3>
              <p className="para">
                {`${project_name}`} for agribusiness keeps track of machinery maintenance,
                seed inventory, warehouse stock, and harvest schedules to maximize annual profitability:
              </p>
              <br />
              <p className="para">
                1. Plan operational task lists aligned with natural crop cycles<br /><br />
                2. Maintain real-time records of silos, cold storage, and physical assets<br /><br />
                3. Keep procurement finances, invoicing, and cash flow under control<br /><br />
                4. Manage certifications, quality compliance, and export documentation<br /><br />
                5. Evaluate employee and farm labor productivity
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}